import { PaymentDto } from '../../pages/users/api/dto/get/PaymentDto'
import { PaymentsDto } from '../../pages/users/api/dto/get/PaymentsDto'
import { PaymentsUI } from '../../pages/users/model/PaymentsUI'
import Payment from './Payment'

class Payments {
  private constructor(total: number, payments: Payment[]) {
    this.total = total
    this.payments = payments
  }

  private readonly total: number
  private readonly payments: Payment[]

  toPaymentsUI(): PaymentsUI {
    return {
      totalPayment: this.total,
      payments: this.payments.map((payment: Payment) => payment.toPaymentUI()),
    } satisfies PaymentsUI
  }

  static fromDto(paymentsDto: PaymentsDto): Payments {
    const { total, payments } = paymentsDto

    return new Payments(
      total,
      payments.map((payment: PaymentDto) => Payment.fromDto(payment)),
    )
  }
}

export default Payments
